import {
  WebsiteContainer,
  WebsiteFooter,
  WebsiteHeading,
  WebsitePage,
  WebsitePageHeader,
  WebsiteSection,
  WebsiteText,
} from "@-/dev.improve.haniverse.components.website";
import type { LegalDocument } from "@-/dev.improve.haniverse.lib.legal";

/** A legal document on the public website, aligned to the page header's left edge. */
export function LegalDocumentPage({
  description,
  document,
}: {
  description: string;
  document: LegalDocument;
}) {
  return (
    <WebsitePage description={description} title={`${document.title} — Haniverse`}>
      <WebsitePageHeader
        description={`Last updated ${document.lastUpdated}`}
        eyebrow="Legal"
        title={document.title}
      />
      <main>
        <WebsiteSection spacing="compact">
          <WebsiteContainer>
            <article className="max-w-[46rem]">
              <WebsiteText size="lead">{document.intro}</WebsiteText>
              {document.sections.map((section) => (
                <section className="mt-12 border-t border-black/12 pt-10" key={section.title}>
                  <WebsiteHeading level={2} size="title">
                    {section.title}
                  </WebsiteHeading>
                  <div className="mt-4 flex flex-col gap-4">
                    {section.paragraphs.map((paragraph) => (
                      <WebsiteText key={paragraph}>{paragraph}</WebsiteText>
                    ))}
                  </div>
                </section>
              ))}
            </article>
          </WebsiteContainer>
        </WebsiteSection>
      </main>
      <WebsiteFooter />
    </WebsitePage>
  );
}
